var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSortDesc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.13306 15.3355L11.3874 17.5899C11.7269 17.9294 12.2753 17.9294 12.6147 17.5899L14.8691 15.3355C15.4174 14.7872 15.0258 13.8471 14.2511 13.8471H9.74235C8.96768 13.8471 8.5847 14.7872 9.13306 15.3355Z",
    fill: "#006DD0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.13306 9.23175L11.3874 6.97737C11.7269 6.63791 12.2753 6.63791 12.6147 6.97737L14.8691 9.23175C15.4174 9.78011 15.0258 10.7202 14.2511 10.7202H9.74235C8.96768 10.7202 8.5847 9.78011 9.13306 9.23175Z",
    fill: "#91919A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortDesc);
export default __webpack_public_path__ + "static/media/sort-desc.6ea72deee93cc490a08fdd1b90a0f492.svg";
export { ForwardRef as ReactComponent };